var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { PartnersBaseComponent } from './../common-theme/index';
var PartnersComponent = /** @class */ (function (_super) {
    __extends(PartnersComponent, _super);
    function PartnersComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PartnersComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.setTitle('Partenerii Dream Residence');
        this.setMetaDescription("Printre partenerii proiectului Dream Residence gasesti companii ca BCR, BRD, BT, Mapei, Mega Door, Porta Doors. Afla toate detaliile pe site.");
    };
    return PartnersComponent;
}(PartnersBaseComponent));
export { PartnersComponent };



// WEBPACK FOOTER //
// ./src/app/partners/partners.component.ts.pre-build-optimizer.js